export default __webpack_public_path__ + "static/media/Akshat.e9d0031a.jpeg";